import { Card, Button, Input, Select, MenuItem, TextField } from "@material-ui/core";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { /* Table, */ Tag, DatePicker } from "antd";
import FadeIn from "react-fade-in/lib/FadeIn"
import { v4 } from 'uuid'
import { getDeleteModalRedux, getSearchTextRedux, getStepRedux, setDeleteModalRedux, setSearchTextRedux, setStepRedux } from "../../../libs/eduPortalManagementSlice"
import { useDispatch, useSelector } from "react-redux"
import axios from "axios";
import { useEffect, useState } from "react";
import { getBizID } from "../../../libs/todoSlice";
import { useCookies } from 'react-cookie';
import Swal from "sweetalert2";
import { getDataRedux, setDataRedux, setDataDetailsRedux, setFilterDataRedux, getFilterDataRedux, setSearchDateRedux, getSearchDateRedux } from "../../../libs/tableSlice";
import { getStyle } from '../../../libs/todoSlice';
import fontColor from '../../../lib/fontColor';
import { getPortalRedux, setPortalRedux } from "../../../libs/eduPortalManagementSlice";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import 'sweetalert2/dist/sweetalert2.min.css';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@mui/material/Tooltip';
import 'moment/locale/th';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { QRCode } from 'react-qrcode-logo';
import { useParams } from "react-router-dom";
import styled from 'styled-components'

const styles = {
  select: {
    border: 'none',
  },
};

const searchParams = useParams

const EduPortalManagementTable = withStyles(styles)(({ classes }) => {

  const dispatch = useDispatch()
  const step = useSelector(getStepRedux)
  const biz_id = useSelector(getBizID)
  const deletemodal = useSelector(getDeleteModalRedux)
  // const searchtext = useSelector(getSearchTextRedux)
  const filterdata = useSelector(getFilterDataRedux)
  // const searchdate = useSelector(getSearchDateRedux)
  const [QRmodalopen, setQRModalOpen] = useState(false)
  const [QRimg, setQRimg] = useState('')
  const [cookie, setCookie, removeCookie] = useCookies(['account'])
  const [isCopied, setIsCopied] = useState(false);
  const [QRimgGen, setQRimgGen] = useState('')
  const [searchtext, setSearchText] = useState('')
  const [searchdate, setSearchDate] = useState('')
  const [searchstatus, setSearchStatus] = useState('')

  const data = useSelector(getDataRedux)
  const setData = (action) => {
    dispatch(setDataRedux({
      data: action
    }))
  }

  const portal = useSelector(getPortalRedux)
  const setPortal = (action) => {
    dispatch(setPortalRedux({
      portal: action
    }))
  }


  const setStep = (action) => {
    dispatch(setStepRedux({
      step: action
    }))
  }

  const setDeleteModal = (action) => {
    dispatch(setDeleteModalRedux({
      deletemodal: action
    }))
  }

  // const setSearchText = (action) => {
  //   dispatch(setSearchTextRedux({
  //     searchtext: action
  //   }))
  // }

  const setFilterData = (action) => {
    dispatch(setFilterDataRedux({
      filterdata: action
    }))
  }

  // const setSearchDate = (action) => {
  //   dispatch(setSearchDateRedux({
  //     searchdate: action
  //   }))
  // }



  useEffect(() => {
    

    if (biz_id)
      getPortal()
    setPortal('')
    setFilterData([])
  }, [biz_id])

  useEffect(() => {
    setQRimgGen('')
  }, [QRmodalopen])

  function convertYear(dateStr) {
    if (!dateStr) return ""; 
    let [day, month, year] = dateStr.split("/").map(Number);
    if (isNaN(day) || isNaN(month) || isNaN(year)) return "";
    if (year >= 67) {
        year = 1900 + year;
    } else {
        year = 2000 + year;
    }
    year -= 543; 
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year % 100}`;
}

  const getPortal = async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/portal?business_id=${biz_id}`, 
      })
      setData(data.data)
      setFilterData(data.data)
      data.data.map(async (obj, index) => {
        try {
          const { data } = await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/portal/setting?business_id=${biz_id}&portal_id=${obj.id}&kind=${obj.kind}`,
          })
          dispatch(setDataDetailsRedux({
            datadetails: data.data,
            index: index
          }))
        }
        catch {

        }
      })
    }
    catch {

    }

  }
  const style = useSelector(getStyle)

  const rows = filterdata


  const delPortal = async (key) => {
    await axios({
      method: 'DELETE',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/portal`,
      data: {
        business_id: biz_id,
        format_id: [
          key
        ]
      }
    }).then(({ data, status }) => {
      Swal.fire({
        title: 'ลบ Form สำเร็จแล้ว',
        icon: 'success',
        zIndex: '9999'
      })
      getPortal()
      setDeleteModal(false)
    }, ({ response }) => {
      setDeleteModal(false)
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'ลบ Form ไม่สำเร็จ'
      })

    })
  }

  const searchFilter = (text, status, dateString) => {

    let dateValue = dateString

    const filtered = data.filter(item => {
      const textfiltered = () => {
        if (text.startsWith("http") || text.startsWith("www")) {
          const searchParams = new URLSearchParams(text);
          const formId = searchParams.get('form_id');
          const formType = searchParams.get('form_type');
          const loginType = searchParams.get('login_type');
          const clientId = searchParams.get('client_id');
          const redirectUrl = searchParams.get('redirect_url');

          return (
            item.id === formId &&
            item.kind === formType &&
            item.loginMethod.some(method => method.name === loginType) &&
            item.clientID === clientId &&
            item.redirectURL === redirectUrl
          );
        }
        else {
          const nonURL = item.name.toLowerCase().includes(text.toLowerCase())
          return nonURL
        }
      }
      const statusfiltered = () => {
        if (status !== '') {
          const result = status === "true" ? true : false
          return item.active === result
        }
        else {
          return data
        }
      }

      const datefiltered = () => {
        if (dateString !== '') {
          const newTime = new Date(dateString);
          const options = {
            day: "numeric",
            month: "numeric",
            year: "2-digit",
          };
          dateValue = newTime.toLocaleDateString('th', options);
          return item.updatedAt.includes(dateValue)
        }
        else {
          return data
        }
      };

      return textfiltered() && statusfiltered() && datefiltered()
    })
    setFilterData(filtered)

  }

  const Buttons = styled.button`
  position: relative;
  width: 192px;
  height: 44px;
  background-color: #FFFFFF;
  color: black;
  border: 1px solid black;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;

  :hover {
    background-color: black;
    color: white;
  }

`;

  return (
    <FadeIn>
      <style>{`
        .swal2-container {
          z-index: 9999;
        }
      `}</style>
      <div className="row my-3">
        <Modal
          open={deletemodal}
          onClose={() => { setDeleteModal(false) }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          data={data}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '344px',
              height: '258px',
              background: '#FFFFFF',
              borderRadius: '12px',
              boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
              p: 2
            }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '5px'
              }}>
              <DeleteForeverIcon style={{ width: '74px', height: '74px', color: 'red' }} />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontSize: '16px',
                fontFamily: 'Sarabun',
                fontWeight: '600',
                color: style.primary_color,
                marginTop: '12px'
              }}>
              คุณต้องการลบฟอร์ม {portal.name}
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontSize: '14px',
                fontFamily: 'Sarabun',
                fontWeight: '400',
                marginTop: '15px',
                color: '#757575'
              }}>
              หากคุณลบข้อมูลทั้งหมดจะหายไป
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '30px',
                fontSize: '14px',
                fontWeight: '800'
              }}>
              <button
                style={{
                  width: '87px',
                  height: '32px',
                  border: `1px solid ${style.primary_color}`,
                  borderRadius: '6px',
                  color: style.primary_color,
                  backgroundColor: '#ffffff',
                  marginRight: '20px'
                }}
                onClick={() => {
                  setDeleteModal(false)
                  setPortal('')
                }}>ยกเลิก</button>
              <button
                style={{
                  width: '87px',
                  height: '32px',
                  border: 'none',
                  borderRadius: '6px',
                  color: fontColor(style.primary_color),
                  backgroundColor: style.primary_color,
                }}
                onClick={() => {
                  delPortal(portal.id)
                }}>ยืนยัน</button>
            </div>
          </Box>
        </Modal>
        <Modal
          open={QRmodalopen}
          onClose={() => {
            setQRModalOpen(false)
            setQRimg('')
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '344px',
              height: '285px',
              background: '#FFFFFF',
              borderRadius: '12px',
              boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
              p: 2
            }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <select
                value={QRimg}
                onChange={(e) => {
                  setQRimgGen('')
                  setQRimg(e.target.value)
                  const test = async () => {
                    try {
                      const { data } = await axios({
                        method: 'POST',
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/user/qr-code`,
                        data: {
                          "business_id": biz_id,
                          "url": `${process.env.REACT_APP_URL_AUTHORIZE}/verify/business?biz_id=${biz_id}&form_id=${portal.id}&form_type=${portal.kind}&login_type=${e.target.value}&token_type=shared_token&client_id=${process.env.REACT_APP_ONE_CLIENT_ID}&redirect_url=${process.env.REACT_APP_ONE_PLATFORM_URL}/manage/api/v1/azure/hook-oneid-login-biz?sharetoken=<shared-token>%26business_id=<business-id>%26business_email=<business-email>`
                          // "url": `${process.env.REACT_APP_URL_AUTHORIZE}/verify/business?biz_id=${biz_id}&form_id=${portal.id}&form_type=${portal.kind}&login_type=${e.target.value}&token_type=shared_token&client_id=${portal.clientID}&redirect_url=${portal.redirectURL}`
                        }
                      }).then((data) => {
                        setQRimgGen(data.data.data.link)
                      }
                      )
                    }
                    catch (err) {
                    }
                  }
                  test()
                }}
                style={{
                  width: '196px',
                  height: '36px',
                  border: '1px solid #EEEEEE',
                  borderRadius: '6px',
                  backgroundColor: '#FFFFFF',
                  color: 'black',
                  top: '45px',
                  marginBottom: '15px',
                }}>
                <option value="">เลือก QR login</option>
                {portal.loginMethod && portal.loginMethod.map((item) => (
                  <>
                    <option value={item.name}>{item.name}</option>
                  </>
                )
                )}
              </select>
            </div>
            {QRimgGen && <div style={{ display: 'flex', justifyContent: 'center' }}><QRCode value={QRimgGen} /></div>}
          </Box>
        </Modal>
        <div className="col">
          <h3 style={{ color: 'black', fontWeight: 'bold' }}>จัดการหน้าลงทะเบียนคนเข้า Business</h3>
          <div>
            <div
              style={{
                position: 'relative',
                display: 'inline-block',
              }}>
              <input
                placeholder="ค้นหาชื่อฟอร์ม, URL"
                value={searchtext}
                style={{
                  position: 'relative',
                  width: '380px',
                  height: '36px',
                  border: '1px solid #EEEEEE',
                  backgroundColor: '#FFFFFF',
                  borderRadius: '6px',
                  marginTop: '40px',
                  marginRight: '15px',
                  marginBottom: '10px',
                  padding: '10px',
                  paddingRight: '2.5rem'
                }}
                onChange={
                  (e) => {
                    setSearchText(e.target.value);
                    searchFilter(e.target.value, searchstatus, searchdate)
                  }}>

              </input>
              <SearchIcon
                style={{
                  position: 'absolute',
                  top: '54%',
                  left: '21.5rem',
                  color: '#DADADA',
                }}
              />
            </div>

            <label
              style={{
                top: '27px',
                left: '5px',
                border: 'none',
                marginBottom: '10px',
                marginRight: '20px',
                marginLeft: '10px'
              }}
              labelId="เลือกสถานะ"
              for='เลือกสถานะ'
            >เลือกสถานะ :</label>
            <select
              labelId="เลือกสถานะ"
              label='เลือกสถานะ'
              onChange={(e) => {
                setSearchStatus(e.target.value)
                searchFilter(searchtext, e.target.value, searchdate)
              }}
              style={{
                width: '196px',
                height: '36px',
                border: '1px solid #EEEEEE',
                borderRadius: '6px',
                backgroundColor: '#FFFFFF',
                color: '#333333',
                top: '45px',
                marginRight: '30px',
                marginBottom: '15px',
                paddingLeft: 5
              }}>
              <option value=''>ทั้งหมด</option>
              <option value="true">active</option>
              <option value="false">inactive  </option>
            </select>
            <DatePicker
              placeholder="เลือกวันที่อัปเดต"
              style={{
                width: '196px',
                height: '36px',
                borderRadius: '4px',
                border: '1px solid #E0E0E0',
              }}
              onChange={(date, dateString) => {
                setSearchDate(dateString)
                searchFilter(searchtext, searchstatus, dateString)
              }}
            />
          </div>
        </div>

      </div>
      <Card
        style={{
          borderRadius: '16px'
        }}>
        <div className="row m-2">
          <div className="col">
            <div style={{
              display: 'flex',
              justifyContent: 'right'
            }}>
              <Buttons
                onClick={() => { setStep('createPortal') }}
              >
                <AddIcon />
                Add Portal Form</Buttons>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">

            {/* <Table dataSource={filterdata} columns={columns} /> */}
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>ชื่อฟอร์ม</TableCell>
                    <TableCell align="center">สถานะ</TableCell>
                    <TableCell align="center">วันที่อัปเดต</TableCell>
                    <TableCell align="center">URL Login</TableCell>
                    <TableCell align="center">QR Code</TableCell>
                    <TableCell align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(rows) && rows.map((row) => (
                  
                    <TableRow
                      key={row.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="center">  <>
                        {row.active === true ?
                          <Tag
                            style={{
                              height: '25px'
                            }} color="green" key={row.active}>
                            Active
                          </Tag>
                          :
                          <Tag color="red" key={row.active}>
                            Inactive
                          </Tag>
                        }
                      </></TableCell>
                      <TableCell align="center">{convertYear(row.updatedAt)}</TableCell>
                      <TableCell align="center">
                        <>
                          <div
                            style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}
                          >
                            {row.loginMethod && row.loginMethod.map((item) =>
                            (<Tooltip title={isCopied ? 'Copied' : `Copy URL ${item.name}`} placement="top">
                              <button
                                onClick={() => {
                                  const linkToCopy = `${process.env.REACT_APP_URL_AUTHORIZE}/verify/business?biz_id=${biz_id}&form_id=${row.id}&form_type=${row.kind}&login_type=${item.name}&token_type=shared_token&client_id=${row.clientID}&redirect_url=${row.redirectURL}`; // Replace with your actual link

                                  navigator.clipboard.writeText(linkToCopy)
                                    .then(() => {
                                      setIsCopied(true);
                                      setTimeout(() => {
                                        setIsCopied(false);
                                      }, 2000);
                                      // You can show a success message or perform other actions here
                                    })
                                    .catch((error) => {
                                      console.error('Error copying link:', error);
                                      // You can show an error message or perform error handling here
                                    });
                                }

                                }
                                style={{
                                  margin: '5px',
                                  background: 'black',
                                  borderRadius: '4px',
                                  color: 'white',
                                  width: 'fit-content',
                                  height: '25px',
                                  marginBottom: '5px',
                                  padding: '5px',
                                  border: '1px solid',
                                  fontSize: '12px',
                                  lineHeight: '10px',
                                  ...(item.name === 'Facebook' && {
                                    borderColor: '#1877F2',
                                    backgroundColor: '#dfebf9',
                                    color: '#1877F2'
                                  }),
                                  ...(item.name === 'Google' && {
                                    borderColor: '#ff0000',
                                    color: '#ff0000',
                                    backgroundColor: '#ffd9d9'
                                  }),
                                  ...(item.name === 'Azure' && {
                                    borderColor: '#04BAF6',
                                    color: '#04BAF6',
                                    backgroundColor: '#e5f8ff',
                                  }),
                                  ...(item.name === 'OneID' && {
                                    borderColor: '#ff9900',
                                    color: '#ff9900',
                                    backgroundColor: '#ffefd8',
                                  }),
                                  ...(item.name === 'OneCollab' && {
                                    borderColor: '#0d00ff',
                                    color: '#0d00ff',
                                    backgroundColor: '#e2e3ff',
                                  }),
                                  ...(item.name === 'MophDID' && {
                                    borderColor: '#3d7655',
                                    color: '#3d7655',
                                    backgroundColor: '#f2fff7',
                                  }),
                                  ...(item.name === 'ThaID' && {
                                    borderColor: '#030c50',
                                    color: '#030c50',
                                    backgroundColor: '#f2f3ff',
                                  }),
                                }}>{item.name}</button>
                            </Tooltip>
                            ))}
                          </div>
                        </>
                      </TableCell>
                      <TableCell align="center">
                        <>
                          <img src="/img/QR_code.png"
                            onClick={() => {
                              setPortal(row)
                              setQRModalOpen(true)
                            }}
                            alt="QR code"
                            key={row.id}
                            style={{
                              width: '32px',
                              height: '32px',
                              cursor: 'pointer'
                            }}
                          />
                        </>
                      </TableCell>
                      <TableCell>
                        <div className="row justify-content-center">
                          <div className="col-3">
                            <button
                              style={{
                                color: '#1890FF',
                                marginRight: '10px',
                                backgroundColor: 'transparent',
                                borderColor: 'transparent',
                                fontSize: '14px'
                              }}
                              onClick={() => {
                                setPortal(row)
                                setStep('editPortal')
                              }}
                            >
                              Edit
                            </button>
                          </div>
                          {/* <div className="col-4">
                            <button
                              // variant="contained"
                              endIcon={<DeleteForeverIcon />}
                              style={{
                                color: 'red',
                                fontSize: '14px',
                                backgroundColor: 'transparent',
                                borderColor: 'transparent',
                              }}
                              key={row.id}
                              onClick={() => {
                                setPortal(row)
                                setDeleteModal(true)
                              }}
                            >
                              Delete <DeleteForeverIcon />
                            </button>
                          </div> */}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </Card>
    </FadeIn >
  )
})

export default EduPortalManagementTable